'use client';

declare global {
  interface Window {
    fbq?: (
      action: 'track' | 'trackCustom' | 'init' | 'consent',
      eventNameOrPixelId: string,
      params?: Record<string, unknown>,
      options?: { eventID?: string },
    ) => void;
  }
}

interface Args {
  eventName: string;
  /** Shared with the server event, so Meta deduplicates the two. */
  eventId: string;
  customData?: Record<string, string>;
}

export function firePixelEvent({ eventName, eventId, customData }: Args): void {
  if (typeof window === 'undefined') return;

  try {
    window.fbq?.('track', eventName, customData, { eventID: eventId });
  } catch (err) {
    console.error('[Meta Pixel] Failed to fire browser event:', err);
  }
}
